import React, {useEffect, useState} from 'react';
import TitleHeader from "main-views/product/TitleHeader";
import {IsLP_MP_SP} from "my-styles/media/media";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Navigation} from "swiper";
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

SwiperCore.use([Navigation])

export default function ImageList(props) {

    const [pageWidth, setPageWidth] = useState(0)
    const boxRef = React.createRef()

    useEffect(() => {
        if (boxRef.current) {
            setPageWidth(boxRef.current.getBoundingClientRect().width)
        }
    }, [boxRef])

    let maxWidth = Math.max.apply(Math, props.list.map((item) => {
        return item.width
    }))
    let marginRightItem = Math.max.apply(Math, props.list.map((item) => {
        return item.margin_right
    }))
    let marginLeftItem = Math.max.apply(Math, props.list.map((item) => {
        return item.margin_left
    }))
    let maxWidthPercent = (pageWidth * (maxWidth / 100))
    let listWidth = 0
    let list

    if (props.isGrid) {

        let rows = []
        for (let i = 0; i < props.list.length; i = i + 2) {
            let current = props.list[i]
            let next = props.list[i + 1]
            let currentHeight = maxWidthPercent * (current.height / 100) + "px"
            let nextHeight = maxWidthPercent * (next.height / 100) + "px"

            rows.push(
                <div className="horizontalFullScreen center" key={Math.random() * 10} >
                    {props.header.type === 3 && (current.margin_right > 0 || current.margin_left > 0) ? <img
                            className={(props.header.hover_animation && props.hover_animation === 1) ? "hoverZoom clickable" : " clickable"}
                            style={{
                                width: current.width + "%", height: currentHeight, marginRight: current.margin_right + 'px',
                                marginLeft: current.margin_left + 'px'
                            }}
                            src={current.image}
                            onClick={() => {
                                props.onClicked(current)
                            }}
                            alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/> :
                        <img
                            className={(props.header.hover_animation && props.hover_animation === 1) ? "hoverZoom clickable" : " clickable"}
                            style={{width: current.width + "%", height: currentHeight}}
                            src={current.image}
                            onClick={() => {
                                props.onClicked(current)
                            }}
                            alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                    }

                    {props.header.type === 3 && (next.margin_right > 0 || next.margin_left > 0) ?
                        <img
                            className={(props.header.hover_animation && props.header.hover_animation === 1) ? "hoverZoom clickable" : " clickable"}
                            style={{
                                width: next.width + "%", height: nextHeight, marginRight: next.margin_right + 'px',
                                marginLeft: next.margin_left + 'px'
                            }}
                            src={next.image}
                            onClick={() => {
                                props.onClicked(next)
                            }}
                            alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/> :
                        <img
                            className={(props.header.hover_animation && props.header.hover_animation === 1) ? "hoverZoom clickable" : " clickable"}
                            style={{width: next.width + "%", height: nextHeight}}
                            src={next.image}
                            onClick={() => {
                                props.onClicked(next)
                            }}
                            alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                    }
                </div>
            )
        }
        list = <div ref={boxRef} key={Math.random()*10}>
            {rows}
        </div>
    } else if (props.isvertical) {
        list = <div ref={boxRef} className={"vertical center hideHScrollInWebShowHScrollInMobile"}>
            {props.list.map((listItem, i) => {
                let heightUnit = maxWidthPercent * (listItem.height / 100) + "px"
                return <div key={i} className="clickable">
                    <img style={{width: listItem.width + "%", height: heightUnit}}
                         src={listItem.image}
                         onClick={() => {
                             props.onClicked(props.list[i])
                         }}
                         alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                </div>
            })}
        </div>
    } else {
        for (let listItem of props.list) {
            listWidth += parseInt(listItem.width)
        }
        if (listWidth > 100 && IsLP_MP_SP()) {
            let spaceBetween = parseInt(marginRightItem) > 0 || parseInt(marginLeftItem) > 0 ? parseInt(parseInt(marginRightItem) + parseInt(marginLeftItem)) : 5
            list = <div ref={boxRef}>
                <Swiper
                    dir="rtl"
                    slidesPerView={100 / maxWidth}
                    spaceBetween={spaceBetween}
                    navigation={true}
                    modules={[Navigation]}
                    autoplay={{
                        delay: 4000,
                        disableOnInteraction: true,
                    }}>
                    {props.list.map((listItem, slideIndex) => {
                        if (pageWidth !== 0) {
                            if (props.header.type === 3 && listItem.margin_right > 0 || listItem.margin_left > 0) {
                                return <SwiperSlide key={slideIndex}
                                                    className="set-margin-right--dynamic set-margin-left--dynamic"
                                                    style={{
                                                        '--margin-right': parseInt(listItem.margin_right) + 'px',
                                                        '--margin-left': parseInt(listItem.margin_left) + 'px'
                                                    }}>
                                    <div className="full">
                                        <img className="clickable full"
                                             src={listItem.image}
                                             onClick={() => {
                                                 props.onClicked(props.list[slideIndex])
                                             }} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                                    </div>
                                </SwiperSlide>
                            } else {
                                return <SwiperSlide key={slideIndex} className="center">
                                    <div className="full">
                                        <img className="clickable full"
                                             src={listItem.image}
                                             onClick={() => {
                                                 props.onClicked(props.list[slideIndex])
                                             }} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                                    </div>
                                </SwiperSlide>
                            }

                        } else {
                            return null
                        }
                    })}
                </Swiper>
            </div>
        } else {
            list = <div ref={boxRef}
                        className={"marginTopBottomSmall horizontalFullScreen hideHScrollInWebShowHScrollInMobile centerInWebRightInMobile"}>
                {props.list.map((listItem, i) => {
                    let heightUnit = maxWidthPercent * (listItem.height / 100) + "px"
                    let imageItem;
                    props.header.type === 3 && (listItem.margin_right && listItem.margin_right > 0) || (listItem.margin_left && listItem.margin_left > 0) ?
                        imageItem = <img
                            key={i}
                            className={(props.header.hover_animation && parseInt(props.header.hover_animation) === 1) ? "hoverZoom clickable" : " clickable"}
                            style={{
                                width: listItem.width + "%",
                                height: heightUnit,
                                marginRight: listItem.margin_right + 'px',
                                marginLeft: listItem.margin_left + 'px'
                            }}
                            src={listItem.image}
                            onClick={() => {
                                props.onClicked(props.list[i])
                            }}
                            alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                        :
                        imageItem = <img
                            key={i}
                            className={(props.header.hover_animation && parseInt(props.header.hover_animation) === 1) ? "hoverZoom clickable" : " clickable"}
                            style={{width: listItem.width + "%", height: heightUnit}}
                            src={listItem.image}
                            onClick={() => {
                                props.onClicked(props.list[i])
                            }}
                            alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>

                    return imageItem;

                })}
            </div>
        }
    }
    return (
        <div style={{marginTop: "1em"}}>
            {props.header.title &&
                <TitleHeader
                    onAllClicked={props.onAllClicked} header={props.header}/>
            }
            {list}
        </div>
    )
}